






































































































import {mapActions, mapGetters} from 'vuex';
import profilePicture from '@/components/profile/ProfilePicture.vue';
import Vue from 'vue';
import {BlackListUser, MyProfileAPI} from '#/User';

interface ComponentData {
  dialog: { display: boolean };
  hasPictureLoaded: boolean;
  user: undefined | MyProfileAPI;
  blacklistLoaded: boolean;
  blacklistOpen: boolean;
}

export default Vue.extend({
  name: 'ProfileDetail',

  components: {
    profilePicture,
  },

  data: (): ComponentData => ({
    dialog: {display: false},
    hasPictureLoaded: false,
    user: undefined,
    blacklistLoaded: false,
    blacklistOpen: false,
  }),

  computed: {
    ...mapGetters([
      'blacklist',
      'hasSyncAction',
      'profile',
    ]),
    ernestLinkAccepted(): boolean {
      return this.user?.useErnestProfile || false;
    },
    blacklistedUsers(): BlackListUser[] {
      return (this.blacklistLoaded && this.blacklistOpen)
          ? this.blacklist : [];
    },
  },

  watch: {
    profile: function () {
      this.user = Object.assign({}, this.profile);
    },
  },

  created() {
    this.updatePageTitle(this.$t('profile.title'));
    this.user = Object.assign({}, this.profile);
  },

  methods: {
    ...mapActions([
      'loadProfile',
      'loadBlacklist',
      'sync',
      'updatePageTitle',
      'updateProfile',
    ]),
    onChangeSwitchValue(): void {
      this.sync(this.user);
    },
    onSaveProfile(): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        this.updateProfile(this.user)
            .then(() => {
              this.$router.push({name: 'AdvertList'})
                  .then(() => {
                    resolve();
                  })
                  .catch(() => {
                    reject();
                  });
            });
      });
    },
    onNavigate(routeName: string): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        this.$router.push(
            {name: routeName},
        )
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
    onOpenPanel(): void {
      if (!this.blacklistLoaded) {
        this.loadBlacklist()
            .then(() => {
              this.blacklistLoaded = true;
              this.blacklistOpen = true;
            });
      } else {
        this.blacklistOpen = !this.blacklistOpen;
      }
    },
    onBlacklistedDetail(userId: number): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        this.$router.push({
          name: 'AuthorDetail',
          params: {authorId: `${userId}`},
        })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
  },
});
